import HyperDX from '@hyperdx/browser'

// Production SPA hostname (Cloudflare Pages custom domain). The browser SDK is
// only initialised here so local dev / preview builds never ship telemetry.
const PROD_HOSTNAME = 'app.savorias.com'

/**
 * Initialise HyperDX browser telemetry (sessions, console capture, network
 * spans). No-op unless running on the production host with a key present, so
 * dev builds and missing-key builds stay silent. The key is a publishable
 * ingestion key — safe to bake into the public bundle, like the Maps key.
 */
export function initObservability(): void {
  const apiKey = import.meta.env.VITE_HYPERDX_KEY
  if (!apiKey || window.location.hostname !== PROD_HOSTNAME) {
    return
  }

  HyperDX.init({
    apiKey,
    service: 'savorias-web',
    consoleCapture: true,
    advancedNetworkCapture: true,
    // Propagate trace headers to the API so browser spans link to API spans.
    tracePropagationTargets: [/savorias-api.*\.run\.app/i, /api\.savorias\.com/i],
  })
}
